// extracted by mini-css-extract-plugin
module.exports = {"header":"Dropdown_header__2XucD","longText":"Dropdown_longText__1q-y0","option":"Dropdown_option__n9HzI"};